"use client"
import { Grid, TextInput, Paper, Title, Container } from "@mantine/core"
import { useForm, isEmail, hasLength } from "@mantine/form"
import { notifications } from "@mantine/notifications"

export default function ConfigPage() {
    const form = useForm({
        initialValues: {
            username: "",
            email: "",
            companyName: "",
            position: "",
            startDate: null as Date | null,
            endDate: null as Date | null,
            singleDay: false,
            onlyUnread: false,
            resources: null as File | null,
        },
        validate: {
            username: hasLength({ min: 2, max: 20 }, "Username must be 2-20 characters long"),
            email: isEmail("Invalid email"),
            companyName: hasLength({ min: 2 }, "Company name must be at least 2 characters long"),
            position: hasLength({ min: 2 }, "Position must be at least 2 characters long"),
            endDate: (value: Date | null, values: any) =>
                value === null
                    ? "End date is required"
                    : values.startDate && value < values.startDate
                        ? "End date must be after start date"
                        : null,
        },
    })

    const handleSubmit = form.onSubmit((values) => {
        console.log(values)
        notifications.show({
            title: "Form submitted",
            message: "Check the console for form values",
            color: "green",
        })
    })

    return (
        <Container size="lg" py="xl">
            <Title order={2} mb="md">
                Configuration
            </Title>
            <form onSubmit={handleSubmit}>
                <Grid gutter="md" grow>
                    <Grid.Col span={12}>
                        <Paper shadow="xs" p="md" h="100%">
                            <Title order={3} mb="md">
                                User Information
                            </Title>
                            <TextInput label="Username" placeholder="Enter username" mb="sm" {...form.getInputProps("username")} />
                            <TextInput
                                label="User Email"
                                placeholder="Enter email"
                                type="email"
                                mb="sm"
                                {...form.getInputProps("email")}
                            />
                            <TextInput
                                label="Company Name"
                                placeholder="Enter company name"
                                mb="sm"
                                {...form.getInputProps("companyName")}
                            />
                            <TextInput label="Position" placeholder="Enter position" mb="sm" {...form.getInputProps("position")} />
                        </Paper>
                    </Grid.Col>
                    {/* <Grid.Col span={12}>
                        <Paper shadow="xs" p="md" h="100%">
                            <Title order={3} mb="md">
                                Additional Settings
                            </Title>
                            <DatePickerInput
                                label="Start Date"
                                placeholder="Pick start date"
                                mb="sm"
                                {...form.getInputProps("startDate")}
                                styles={{
                                    input: { minWidth: '250px' }, // Input field size
                                }}
                                popoverProps={{
                                    withinPortal: false,
                                    styles: { dropdown: { width: '250px' } },
                                }}
                            />
                            <DatePickerInput
                                label="End Date"
                                placeholder="Pick end date"
                                mb="sm"
                                {...form.getInputProps("endDate")}
                                styles={{
                                    input: { minWidth: '250px' },
                                }}
                                popoverProps={{
                                    withinPortal: false,
                                    styles: {
                                        dropdown: { width: '250px' },
                                    },
                                }}
                            />
                            <Checkbox label="Single Day" mb="sm" {...form.getInputProps("singleDay", { type: "checkbox" })} />
                            <Checkbox label="Only Unread" mb="sm" {...form.getInputProps("onlyUnread", { type: "checkbox" })} />
                            <FileInput
                                label="Upload Resources"
                                placeholder="Upload file"
                                accept="pdf"
                                mb="sm"
                                styles={{
                                    input: { minWidth: '250px' },
                                }}
                                {...form.getInputProps("resources")}
                            />
                            <Button type="submit" mt="md">
                                Save Configuration
                            </Button>
                        </Paper>
                    </Grid.Col> */}
                </Grid>
            </form>
        </Container>
    )
}

